<template>
  <div class="container">
    <div class="q-mt-xl">
      <div class="q-my-lg">
        <div>
          <p></p>
          <q-btn
            label="Criar Novo"
            no-caps
            icon="add"
            color="positive"
            class="btn"
            @click="rightDrawerOpen = true"
          />
        </div>
      </div>
      <div class="q-mt-xl">
        <div class="row col-12 justify-between items-center q-mb-sm">
          <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
            Depósitos Criados
          </div>
          <div class="row col-md-3 col-xs-12 justify-end">
            <q-input
              rounded
              outlined
              dense
              debounce="300"
              type="text"
              class="col-md col-xs-7 input"
              placeholder="Pesquisar"
              v-model="filtros.deposito"
            >
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>
          </div>
        </div>
        <q-linear-progress v-if="loading" indeterminate size="3px" />
        <q-table
          :columns="columns"
          :rows="listaDeposito"
          dense
          :hide-bottom="!listaDeposito.length == 0"
          no-data-label="Nenhum depósito criado."
          :class="{ 'my-sticky-dynamic': !mobile }"
          flat
          :grid="mobile"
          :rows-per-page-options="[0]"
          row-key="depositoUuid"
        >
          <template v-slot:item="props">
            <div class="q-pa-xs row col-12">
              <q-card class="container-grid-table col-12">
                <div class="q-pa-sm">
                  <div class="row col-12 items-center">
                    <div class="col-8">
                      <div
                        style="word-break: break-all"
                        class="row col-12 items-center"
                      >
                        <strong class="q-mr-xs">Nome:</strong>
                        <span>{{ props.row.nome }}</span>
                      </div>
                    </div>
                    <div class="col">
                      <div class="row col-12 justify-end">
                        <div>
                          <q-btn
                            icon="domain"
                            flat
                            round
                            color="secondary"
                            @click="
                              (rightDrawerOpen = true),
                                (criarLocal = true),
                                (dadoDeposito = props.row),
                                (depositoUuid = props.row.depositoUuid)
                            "
                          />
                        </div>
                        <div class="q-ml-xs">
                          <q-btn
                            icon="delete"
                            flat
                            round
                            color="red"
                            @click="excluirDeposito(props.row.depositoUuid)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </q-card>
            </div>
          </template>
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th
                class="text-weight-bolder"
                v-for="col in props.cols"
                :key="col.name"
                :props="props"
              >
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr class="text-brand-5 text-weight-bold">
              <q-td>
                <span>{{ props.row.nome }}</span>
              </q-td>
              <q-td class="coluna-btn">
                <q-btn
                  icon="domain"
                  flat
                  round
                  color="secondary"
                  @click="
                    (rightDrawerOpen = true),
                      (criarLocal = true),
                      (dadoDeposito = props.row),
                      (depositoUuid = props.row.depositoUuid)
                  "
                />
              </q-td>
              <q-td class="coluna-btn">
                <q-btn
                  icon="delete"
                  flat
                  round
                  color="red"
                  @click="excluirDeposito(props.row.depositoUuid)"
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
        <div v-if="listaDeposito.length > 0" class="row justify-center q-mt-md">
          <q-pagination
            :disable="disable"
            v-model="pagination.page"
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            :max="pagesNumber"
            :max-pages="5"
            :boundary-numbers="false"
            :direction-links="true"
            :size="mobile ? 'md' : 'sm'"
          />
        </div>
      </div>
      <Transition name="slide-fade">
        <q-card v-if="rightDrawerOpen" class="drawer-modal">
          <div class="row q-pa-md text-weight-bold">
            <div class="row col-12 items-center">
              <q-icon
                style="cursor: pointer"
                name="close"
                class="q-mr-md"
                size="22px"
                @click="rightDrawerOpen = false"
              />
              <span v-if="!criarLocal" class="texto-titulo-modal">
                Criar Depósito
              </span>
              <span v-else class="texto-titulo-modal">
                Criar Local {{ dadoDeposito.nome }}
              </span>
            </div>
          </div>
          <div
            v-if="criarLocal"
            class="justify-end row col-md-12 col-lg-12 col-xs-12 q-mt-xs"
          >
            <div class="row col-12 col-xs-12 container-tab justify-end">
              <q-tabs v-model="tab" narrow-indicator dense align="right">
                <q-tab
                  class="text-black"
                  no-caps
                  name="adicionar"
                  label="Adicionar"
                />
                <q-tab class="text-black" no-caps name="lista" label="Lista" />
              </q-tabs>
            </div>
          </div>
          <div v-if="!criarLocal" style="width: 100%; height: 85%">
            <div class="column col-12 justify-between no-wrap container-modal">
              <div class="q-px-md text-weight-bold">
                <div>
                  <div class="texto-titulo-input">Nome</div>
                  <q-input
                    class="input-modal"
                    v-model="dado.nome"
                    dense
                    outlined
                  />
                </div>
              </div>
              <div class="q-my-sm q-px-md">
                <q-btn
                  label="Criar"
                  color="positive"
                  no-caps
                  icon="done"
                  @click="criarDeposito()"
                />
              </div>
            </div>
          </div>
          <div
            v-if="tab == 'adicionar' && criarLocal"
            style="width: 100%; height: 85%"
          >
            <div class="column col-12 justify-between no-wrap container-modal">
              <div class="q-px-md text-weight-bold">
                <div>
                  <div class="texto-titulo-input">Nome</div>
                  <q-input
                    class="input-modal"
                    v-model="dado.nome"
                    dense
                    outlined
                  />
                </div>
              </div>
              <div class="q-my-sm q-px-md q-mb-lg">
                <q-btn
                  label="Criar"
                  color="positive"
                  no-caps
                  icon="done"
                  @click="criarDepositoLocal()"
                />
              </div>
            </div>
          </div>
          <q-scroll-area
            v-if="tab == 'lista' && criarLocal"
            style="width: 100%; height: 85%"
          >
            <div class="column col-12 justify-between no-wrap container-modal">
              <div class="q-px-md text-weight-bold">
                <div>
                  <div class="row col-12 q-my-md">
                    <div class="row col-12 texto-titulo-tabela">
                      Lista de Locais Depósito: {{ dadoDeposito.nome }}
                    </div>
                    <div class="row col-12 justify-end q-mt-sm">
                      <q-input
                        rounded
                        outlined
                        dense
                        debounce="300"
                        type="text"
                        class="col-6 input"
                        placeholder="Pesquisar"
                        v-model="filtros.local"
                      >
                        <template v-slot:append>
                          <q-icon name="search" />
                        </template>
                      </q-input>
                    </div>
                  </div>
                  <div
                    v-for="(local, index) in dadoDeposito?.locais"
                    :key="index"
                    class="row col-md-12 q-mt-xs q-pa-sm items-center"
                    style="border: 1px solid; border-radius: 5px"
                  >
                    <div class="row col-12 justify-between items-center">
                      <span class="row col-10 texto-conteudo-tabela"
                        >{{ index + 1 }}- {{ local.local }}</span
                      >
                      <div class="col">
                        <q-btn
                          icon="delete"
                          flat
                          round
                          color="red"
                          @click="excluirDepositoLocal(local.depositoLocalUuid)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </q-scroll-area>
        </q-card>
      </Transition>
    </div>
    <div
      v-if="rightDrawerOpen"
      @click="(rightDrawerOpen = false), (criarLocal = false)"
      class="mascara"
    ></div>
  </div>
</template>

<script>
import { useQuasar } from "quasar";
import { onMounted, ref, computed, watch } from "vue";
import { useStore } from "vuex";

const columns = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "locais",
    label: "Locais",
    align: "left",
  },
  {
    name: "excluir",
    label: "Excluir",
    align: "left",
  },
];

export default {
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    let rightDrawerOpen = ref(false);
    let rightDrawerOpenLocais = ref(false);
    let criarLocal = ref(false);
    const listaDeposito = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    const filtros = ref({ deposito: "", local: "" });
    const dado = ref({ nome: "" });
    const dadoDeposito = ref({});
    const tab = ref("adicionar");
    const depositoUuid = ref("");
    let loading = ref(false);
    let disable = ref(false);
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const listarDeposito = async () => {
      await store.state.org.unidadeData.id;
      loading.value = true;
      disable.value = true;
      try {
        const response = await store.dispatch("ferramentaria/listarDeposito", {
          unidadeId: store.state.org.unidadeData.id,
          nome: filtros.value.deposito,
        });
        listaDeposito.value = response.data.resultado.dados;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
        loading.value = false;
        disable.value = false;
      }
    };

    const criarDeposito = async () => {
      try {
        await store.dispatch("ferramentaria/criarDeposito", {
          nome: dado.value.nome,
          unidadeId: store.state.org.unidadeData.id,
        });
        resetVariaveis();
        listarDeposito();
        rightDrawerOpen.value = false;
        quasar.notify({
          message: "Depśito criado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        if (error.response.data?.erros?.mensagem) {
          quasar.notify({
            message: error.response.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response.data?.erro?.mensagem) {
          quasar.notify({
            message: error.response.data?.erro?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const criarDepositoLocal = async () => {
      try {
        await store.dispatch("ferramentaria/criarDepositoLocal", {
          depositoUuid: dadoDeposito.value?.depositoUuid,
          local: dado.value.nome,
        });
        resetVariaveis();
        listarDeposito();
        quasar.notify({
          message: `Local criado no depósito ${dadoDeposito.value.nome} com sucesso."`,
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        atualizarListaDeposito(dadoDeposito.value?.depositoUuid);
      } catch (error) {
        if (error.response.data?.erros?.mensagem) {
          quasar.notify({
            message: error.response.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response.data?.erro?.mensagem) {
          quasar.notify({
            message: error.response.data?.erro?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const resetVariaveis = () => {
      dado.value = {
        nome: "",
      };
    };

    const excluirDeposito = async (depositoUuid) => {
      try {
        await store.dispatch("ferramentaria/excluirDeposito", {
          depositoUuid,
        });
        quasar.notify({
          message: "Deposito excluído com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarDeposito();
      } catch (error) {
        console.log(error);
        if (error.response.data?.erro?.mensagem) {
          quasar.notify({
            message: error.response.data?.erro?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response.data?.erros?.mensagem) {
          quasar.notify({
            message: error.response.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const excluirDepositoLocal = async (depositoLocalUuid) => {
      try {
        await store.dispatch("ferramentaria/excluirDepositoLocal", {
          depositoLocalUuid,
        });
        quasar.notify({
          message: "Deposito excluído com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        atualizarListaDeposito(dadoDeposito.value?.depositoUuid);
      } catch (error) {
        console.log(error);
        if (error.response.data?.erro?.mensagem) {
          quasar.notify({
            message: error.response.data?.erro?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response.data?.erros?.mensagem) {
          quasar.notify({
            message: error.response.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const atualizarListaDeposito = async (depositoUuid) => {
      try {
        const response = await store.dispatch("ferramentaria/listarDeposito", {
          unidadeId: store.state.org.unidadeData.id,
          nomeLocal: filtros.value.local,
        });
        listaDeposito.value = response.data.resultado.dados;
        let array = listaDeposito.value.filter(
          (deposito) => deposito.depositoUuid == depositoUuid
        );
        dadoDeposito.value = { ...array[0] };
      } catch (error) {
        console.log(error);
        loading.value = false;
        disable.value = false;
      }
    };

    watch(
      () => filtros.value.deposito,
      () => {
        listarDeposito();
      }
    );

    watch(
      () => filtros.value.local,
      () => {
        atualizarListaDeposito(depositoUuid.value);
      }
    );

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        listarDeposito();
      }
    );

    onMounted(() => {
      listarDeposito();
    });

    return {
      columns,
      rightDrawerOpen,
      listarDeposito,
      listaDeposito,
      depositoUuid,
      pagination,
      excluirDepositoLocal,
      filtros,
      criarDeposito,
      loading,
      disable,
      rightDrawerOpenLocais,
      criarLocal,
      tab,
      excluirDeposito,
      dado,
      mobile,
      dadoDeposito,
      criarDepositoLocal,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
.container {
  height: 100% !important;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
.input {
  width: 180px;
}
tbody tr .coluna-btn {
  width: 120px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100% !important;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.container-modal {
  height: 100%;
}
.input {
  width: 180px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
.titulo-tabela {
  font-size: 18px;
}
.texto-titulo-modal {
  font-size: 16px;
}
tbody tr .coluna-btn {
  width: 120px;
}
@media (max-width: 1400px) {
  .drawer-modal {
    height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1000px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 100%;
    height: 85%;
    overflow: hidden;
    top: 103px;
    width: 340px;
  }
  .btn {
    font-size: 12px;
  }
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .input-mobile {
    width: 90px;
    outline: none;
  }
  .texto-titulo-modal {
    font-size: 14px;
  }
  .input-modal {
    font-size: 12px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
}
@media (max-width: 372px) {
  .btn {
    font-size: 11px;
  }
}
</style>
